import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

export default function StandLogin() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { standLogin } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const data = await standLogin(username, password);
      navigate(`/backoffice/${data.stand.id}`);
    } catch (err) {
      setError(err.message);
    }
    setLoading(false);
  };

  const inputClass = "w-full bg-white border border-[#E2D1B8] rounded-xl px-4 py-3 text-[#332A1C] placeholder-[#C9B494] focus:outline-none focus:border-[#C4673D] focus:ring-2 focus:ring-[#C4673D]/20 transition";

  return (
    <div className="min-h-screen bg-[#FEFCF8] flex flex-col items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <h1 className="font-serif text-3xl text-[#332A1C]">Espace Gérant</h1>
          <p className="text-[#8B7355] mt-1">Back-office des Halles de la Cartoucherie</p>
        </div>

        <form onSubmit={handleSubmit} className="bg-white rounded-2xl border border-[#F3DFC0] shadow-sm p-6 space-y-4">
          <div>
            <label className="block text-sm text-[#8B7355] mb-1.5">Identifiant du stand</label>
            <input type="text" placeholder="ex: les_canons_de_la_daronne" value={username} onChange={e => setUsername(e.target.value)} required className={inputClass} />
          </div>
          <div>
            <label className="block text-sm text-[#8B7355] mb-1.5">Mot de passe</label>
            <input type="password" placeholder="Mot de passe" value={password} onChange={e => setPassword(e.target.value)} required className={inputClass} />
          </div>

          {error && <p className="text-red-600 text-sm bg-red-50 p-3 rounded-xl">{error}</p>}

          <button type="submit" disabled={loading}
            className="w-full bg-[#C4673D] text-white py-3.5 rounded-xl font-semibold hover:bg-[#A8532E] transition disabled:opacity-50">
            {loading ? 'Connexion...' : 'Accéder au back-office'}
          </button>
        </form>

        <div className="text-center mt-6">
          <Link to="/login" className="text-[#8B7355] text-sm hover:text-[#C4673D] transition">
            ← Retour à l'accueil client
          </Link>
        </div>
      </div>
    </div>
  );
}
